export default "/assets/ollie_calendar-78a0b1b22db9c6eafcebe8391870ac8f8d9f3cb82030c426507ea80f7bea0078.svg";